<template>
  <page bg-color="#f5f5f5">
    <div class="coupon-hint">
      <div class="hint-text">
        已兑换的优惠券请前往“<span style="color: #333">我的优惠券</span>”查看
      </div>
      <div class="check-entry" @click="handleJumpCoupon">
        去查看
        <img class="arrow" src="@/images/integral/checkArrow.png" />
      </div>
    </div>

    <div class="hint">
      商品兑换成功后将由专属VIP客服联系您兑现，您也可以主动联系您的专属VIP客服哦~
    </div>

    <div class="history-list-container">
      <div v-for="item in list" :key="item.id" class="history-card">
        <div class="title-line">
          <div class="title">
            {{ item.goodsName }}
          </div>
          <div class="value">
            价值¥<span class="money">{{ item.goodsAmount }}</span>
          </div>
        </div>
        <div class="time">
          {{ formatTime(item.ut) }}
        </div>
        <div class="status">兑换成功</div>
      </div>
    </div>
  </page>
</template>

<script>
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
import { navBar } from '@/utils/native_interactions/native_bar'
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  beforeRouteEnter(to, from, next) {
    next(v => {
      navBar.setTitle({
        text: '已兑换'
      })
      document.title = '已兑换'
    })
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getHistoryList()
  },
  methods: {
    ...mapActions('integral', ['queryExchangeTrigger']),
    handleJumpCoupon() {
      nativeRedirect(nativeRoutes.myCoupons)
    },
    formatTime(time) {
      return dayjs.unix(time).format('YYYY.MM.DD HH:mm:ss')
    },
    async getHistoryList() {
      try {
        const res = await this.queryExchangeTrigger()
        this.list = res
      } catch (e) {
        this.$catch(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-hint {
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  height: 44px;
  font-size: 13px;
  border-top: 1px solid #f5f5f5;
  color: #999;

  & > .hint-text {
    flex: 1;
  }

  & > .check-entry {
    color: #ff5c00;

    & > .arrow {
      width: 5px;
      margin-left: 2px;
    }
  }
}

.hint {
  color: #333;
  font-size: 13px;
  padding: 12px 15px 12px 15px;
  line-height: 18px;
}

.history-list-container {
  padding: 0 15px 40px 15px;

  & > .history-card {
    background-color: white;
    border-radius: 6px;
    margin-bottom: 12px;
    padding: 12px 15px;

    .title-line {
      margin-bottom: 8px;
      display: flex;
      flex-direction: row;
      .title {
        flex: 1;
        line-height: 20px;
        color: #333;
        font-size: 14px;
        font-weight: bold;
      }

      .value {
        color: #ff5c00;
        line-height: 20px;
        font-size: 12px;

        & > .money {
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    & > .time,
    .status {
      line-height: 17px;
      color: #666;
      font-size: 12px;
    }

    & .time {
      margin-bottom: 8px;
    }
  }
}
</style>
